import {
    Box,
    Image,
    Flex
} from '@chakra-ui/react'
import { colors } from 'src/common/colors'
import { ChevronRightIcon } from "@chakra-ui/icons"
import { PlayerData } from "src/hooks/SearchInfo/useGetPlayers"
import styled from 'styled-components'

type Props = {
    player: PlayerData
}

export const PlayerBox = (props: Props) => {
    const { player } = props

    const dateSlice = (birthday: string) => {
        const cleanedBirthday = birthday.replace(/\D/g, '')
        return `${cleanedBirthday.slice(0, 4)}.${cleanedBirthday.slice(4, 6)}.${cleanedBirthday.slice(6)}`
    }

    return (
        <>
            <Flex
                alignItems='center'
                justifyContent='space-between'
            >
                <Flex>
                    <Box
                        width='73px'
                        height='73px'
                        border={`2px solid ${colors.button.blue}`}
                        borderRadius='50%'
                        overflow='hidden'
                        marginRight='18px'
                    >
                        <Image
                            width='100%'
                            height='100%'
                            objectFit='cover'
                            src={player.childrenImageUrl}
                            alt={player.childrenName}
                        />
                    </Box>
                    <Flex direction='column' justifyContent='center'>
                        <Flex>
                            <ClubDetailBox fontFamily='NanumSquareNeoEBold' color={`${colors.darkBlue}`} fontSize='24px' lineHeight='162%'>
                                {player.childrenName}
                            </ClubDetailBox>
                            <ClubDetailBox fontSize='16px' margin='10px 0 0 8px' lineHeight='162%'>
                                {dateSlice(player.childrenBirthDay)}
                            </ClubDetailBox>
                        </Flex>
                        <ClubDetailBox color={`${colors.button.blue}`} fontSize='16px' lineHeight='162%'>
                            {player.childrenAcademyName}  |  {player.childrenLevel}
                        </ClubDetailBox>
                    </Flex>
                </Flex>
                <ChevronRightIcon
                    position='relative'
                    right='0'
                    boxSize='48px'
                    flexShrink='0'
                    color={colors.button.blue}
                />
            </Flex>
        </>
    )
}

const ClubDetailBox = styled(Box)`
    @media (max-width: 1510px) {
        max-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`